module.exports = __webpack_public_path__ + "static/media/ic_message_white.ce0ed61a.svg";